import { Injectable } from '@angular/core';
import { ITimeBlockComponentItem } from '../../calendar/components/time-block/types/time-block-component-item-types';
import { SlotHandlerService } from '../../../core/services/features/fix-interval-planner/slot-handler.service';
import { TimeBlockIntersectionService } from '../../calendar/components/time-block/calculation/intersection/time-block-intersection.service';
import { Slot } from '../../calendar/components/time-block/calculation/geometry/slot/slot';
import { AbsencePlannerEventModel } from '../../../core/models/absence-planner/absence-planner-event.model';
import { AbsencePlannerEventConverter } from '../converter/absence-planner-event.converter';

@Injectable({
  providedIn: 'root',
})
export class AbsencePlannerParallelIndexCalculator {
  constructor(
    private readonly slotHandlerService: SlotHandlerService,
    private readonly timeBlockIntersectionService: TimeBlockIntersectionService,
  ) {}

  public calculate(plannerEventModels: AbsencePlannerEventModel[]): void {
    const slots = new Array<Slot>();

    const timeBlocks = plannerEventModels.map((plannerEventModel) =>
      AbsencePlannerEventConverter.toITimeBlockComponentItem(plannerEventModel),
    );

    // fill in fix interval time blocks first
    this.slotHandlerService.orderFixIntervalTimeBlocks(timeBlocks);
    timeBlocks.forEach((timeBlock: ITimeBlockComponentItem) => {
      this.slotHandlerService.assignTimeBlockToSlot(
        timeBlock,
        slots,
        this.timeBlockIntersectionService,
        true,
      );
    });

    this.slotHandlerService.updateGeometryHorizontalSlots(slots);
  }
}
